(function() {
  document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
      return html`
        <div class="ais-page">
          <h2 class="ais-h2" style="display: none;">${algoliaShopify.translations.searchTitle}</h2>
          <div class="ais-input" style="display: none;">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-facets-button">
            Show filters
          </div>
           <div class="ais-facets">
            <div class="ais-facets--header-main">
              <h5>Filters</h5>
              <div class="ais-facets-button-close-modal-icon">Close</div>
            </div>
            <div class="ais-facets--title-clear">
              <div class="ais-facets--title">Filters</div>
              <div class="ais-clear-refinements-container"></div>
            </div>
            <div class="ais-no-filter-message" style="font-size: 13px; font-style: normal; font-weight: 400; line-height: 120%; color: var(--color-grey-600); margin-bottom: 20px;">No filters applied.</div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map(
              (facet) =>
                html`
                  <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                    <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header"
                      >${facet.title}</label
                    >
                    <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                    <div class="ais-facets-dropdown-wrapper">
                      <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                      <div class="ais-RefinementList-showMore">
                        <span>Show more</span>
                      </div>
                    </div>
                  </div>
                `
            )}
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display" style="display: none;">
                <span class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      ${algoliaShopify.translations.sortBy}
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html`
                      ${algoliaShopify.translations.sortBy}
                      ${algoliaShopify.translations.relevance}
                    `}
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
    });
  });

  const combinedHeights = [];
  const userToggledMaxHeight = [];

  // Set the title to the search query
  const searchDisplay = setInterval(() => {
    const page = document.querySelector('.ais-page');
    if (page) {
      const originalString = document.querySelector('.ais-SearchBox-input');
      const parentElement = document.querySelector('.ais-stats-container');
      const newString = originalString?.value;

      parentElement.innerHTML = newString;
      parentElement.style.textTransform = 'capitalize';
      parentElement.style.fontWeight = '600';
      page.style.display = 'block';
      clearInterval(searchDisplay);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(searchDisplay);
  }, 10000);

  const observerInterval = setInterval(() => {
    const page = document.querySelector('.ais-page');
    if (page) {

      const mutationCallback = (mutationsList) => {

        for (const mutation of mutationsList) {
          // Watch for filters to hide or show the 'No Filter' message
          const refinedValuesList = document.querySelector('.ais-current-refined-values--list');
          const noFilterMessage = document.querySelector('.ais-no-filter-message');
          if (refinedValuesList.children.length > 0) {
            noFilterMessage.style.display = 'none';
          } else {
            noFilterMessage.style.display = 'block';
          }

          // Count the number of .ais-RefinementList-item elements inside the wrapper
          const facetDropdownWrappers = document.querySelectorAll('.ais-facet-dropdown-wrapper');
          facetDropdownWrappers.forEach((wrapper, index) => {
            const refinementListItems = wrapper.querySelectorAll('.ais-RefinementList-item');
            const showMoreButtons = document.querySelectorAll('.ais-RefinementList-showMore')[index];

            if (refinementListItems.length < 6) {
              showMoreButtons.style.display = 'none';
            } else {
              showMoreButtons.style.display = 'block';
            }

            // Hide the wrapper if there are no elements inside
            if (!refinementListItems.length) {
              wrapper.style.display = 'none';
            } else {
              wrapper.style.display = 'block';
            }
          });

           // Calculate the combined height of the first 5 elements
          const facetDropdownContainers = document.querySelectorAll('.ais-facet-dropdown-container');
          facetDropdownContainers.forEach((container, index) => {
            const refinementListItemsSliced = Array.from(container.querySelectorAll('.ais-RefinementList-item')).slice(0, 5);

            let combinedHeight = 0;
            refinementListItemsSliced.forEach((item) => {
              combinedHeight += item.offsetHeight;
            });

            combinedHeights[index] = combinedHeight;
            userToggledMaxHeight[index] = userToggledMaxHeight[index] || false;

            const refinementListItems = Array.from(container.querySelectorAll('.ais-RefinementList-item'));
            if (refinementListItems.length > 5 && !userToggledMaxHeight[index]) {
              container.style.maxHeight = `${combinedHeight}px`;
              container.style.overflow = 'hidden';
            }
          });
        }
      };

      const observer = new MutationObserver(mutationCallback);

      observer.observe(page, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      clearInterval(observerInterval);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(observerInterval);
  }, 10000);

  // Show More/Show Less logic
  const showMoreInterval = setInterval(() => {
    const showMoreButtons = document.querySelectorAll('.ais-RefinementList-showMore span');
    if (showMoreButtons.length > 0) {
      showMoreButtons.forEach((showMoreButton, index) => {
        showMoreButton.addEventListener('click', () => {
          const facetsWrapper = showMoreButton.parentElement.previousElementSibling;
          if (facetsWrapper && facetsWrapper.style.maxHeight) {
            facetsWrapper.style.maxHeight = null;
            facetsWrapper.style.overflow = 'visible';
            showMoreButton.innerText = 'Show less';
            userToggledMaxHeight[index] = true;
          } else if (facetsWrapper) {
            facetsWrapper.style.maxHeight = `${combinedHeights[index]}px`;
            facetsWrapper.style.overflow = 'hidden';
            showMoreButton.innerText = 'Show more';
            userToggledMaxHeight[index] = false;
          }
        });
      });
      clearInterval(showMoreInterval);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(showMoreInterval);
  }, 10000);

  // Add back event listener for closing mobile filters since it is being removed with the custom logic
  const mobileCloseInterval = setInterval(() => {
    const closeButton = document.querySelector('.ais-facets-button-close-modal-icon');
    const facetsButton = document.querySelector('.ais-facets-button');
    const facetsContainer = document.querySelector('.ais-facets');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        if (facetsContainer.classList.contains('ais-facets__shown')) {
          facetsContainer.classList.remove('ais-facets__shown');
          facetsButton.innerText = 'Show Filters'
        }
      })
      clearInterval(mobileCloseInterval);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(mobileCloseInterval);
  }, 10000);
})();
